var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50098 6.50061H17.4997V17.4994H6.50098V6.50061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8398 10.4606L13.3442 11.1806L14.1355 10.6031V14.7806H14.9998V9.3075H14.2798L12.8398 10.4606Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4709 11.8725C11.784 11.5856 11.9771 11.1881 11.9771 10.7475C11.9771 9.87377 11.2103 9.16315 10.269 9.16315C9.4684 9.16315 8.78402 9.6694 8.60402 10.3913L9.43277 10.6013C9.51527 10.2694 9.8659 10.0275 10.269 10.0275C10.7396 10.0275 11.124 10.3519 11.124 10.7475C11.124 11.145 10.7396 11.4675 10.269 11.4675H9.77027V12.3319H10.269C10.809 12.3319 11.2665 12.7069 11.2665 13.1513C11.2665 13.6031 10.8334 13.9725 10.3009 13.9725C9.81902 13.9725 9.4084 13.6669 9.34277 13.2638L8.49902 13.4006C8.63027 14.2181 9.40465 14.8369 10.299 14.8369C11.304 14.8369 12.1196 14.0813 12.1196 13.1513C12.1196 12.6413 11.8684 12.1819 11.4709 11.8725Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 21H6.99973L6.50098 18.9994L6.99973 17.0006H17.001L17.4997 18.9994L17.001 21Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 17.4994L21.0004 17.0006V6.99936L18.9997 6.50061L17.001 6.99936V17.0006L18.9997 17.4994Z",
    fill: "#4CAF50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0006 6.99938L17.4994 5.00063L17.0006 3H4.5C3.67125 3 3 3.67125 3 4.5V17.0006L5.00063 17.4994L6.99938 17.0006V6.99938H17.0006Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 17.0006V21L21.0004 17.0006H17.001Z",
    fill: "#E53935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5004 3H17.001V6.99938H21.0004V4.5C21.0004 3.67125 20.3291 3 19.5004 3Z",
    fill: "#1565C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21H6.99938V17.0006H3V19.5C3 20.3287 3.67125 21 4.5 21Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/GoogleCalendar.cde614ea8da896b72006882c7d46357a.svg";
export { ForwardRef as ReactComponent };